import { motion } from "framer-motion";
import { fadeUp, slideRight, slideLeft } from "../../animations/variants";
import { useSelector } from "react-redux";
import { heroText } from "i18n/hero";
import { FaMotorcycle, FaShoppingBag, FaUtensils } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const Hero = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = heroText[lang];
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    setOpen(false);

    // If NOT on homepage → navigate there first
    if (location.pathname !== "/") {
      navigate("/" + id); // example: "/#services"
      return;
    }

    // If already on homepage → scroll normally
    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const [menuType, setMenuType] = useState("lunch");

  const handleToggleMenu = () => {
    const nextType = menuType === "lunch" ? "dinner" : "lunch";
    setMenuType(nextType);
    navigate(`/menu/${nextType}`);
  };
  useEffect(() => {
    const hour = new Date().getHours();

    if (hour < 17) {
      setMenuType("lunch");
    } else {
      setMenuType("dinner");
    }
  }, []);

  const currentLabel = menuType === "lunch" ? "Lunch Menu" : "Dinner Menu";

  return (
    <section
      // className="relative pt-28 pb-20 px-6 min-h-screen text-white overflow-hidden hero-bg-animate"
      className="relative pt-28 pb-20 min-h-screen text-white overflow-hidden hero-bg-animate"
      style={{
        backgroundImage: `
          linear-gradient(
            to right,
            rgba(3,7,18,0.92),
            rgba(3,7,18,0.75),
            rgba(3,7,18,0.3)
          ),
          url("/saigonstar/bghero.webp")
        `,
        backgroundSize: "cover",
        backgroundPosition: "right center",
      }}
    >
      {" "}
      {/* soft glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(255,0,60,0.12),transparent_60%)]" />
      <div className="relative max-w-6xl px-6 mx-auto grid md:grid-cols-2 gap-3 md:gap-12 min-h-[85vh] order-2 items-stretch">
        {/* LEFT */}
        <motion.div
          variants={slideLeft}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="h-full flex flex-col justify-center text-center md:text-left"
        >
          <motion.h1
            variants={fadeUp}
            className="
    text-4xl md:text-5xl lg:text-6xl
    font-semibold
        font-heading
    leading-[1.5]

    uppercase
    tracking-tight
    max-w-[500px]
  "
          >
            <span className="block text-drylightlight capitalize">
              {t.title.line1}
            </span>
            <span className="block capitalize mt-0 text-yellowstar bg-clip-text text-transparent drop-shadow-[0_0_25px_rgba(255,80,80,0.5)]">
              {t.title.highlight}
            </span>
          </motion.h1>

          <motion.p
            variants={fadeUp}
            className="mt-6 text-base md:text-lg text-gray-300 max-w-md mx-auto md:mx-0"
          >
            {t.description}
          </motion.p>

          {/* CTA buttons */}
          <motion.div
            variants={fadeUp}
            className="flex flex-col gap-6 lg:flex-row mt-6"
          >
            <button
              className="mt-0 inline-block"
              onClick={() => scrollToSection("#category")}
            >
              <div className="heroneon-fill cursor-pointer select-none  min-w-[200px]">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span className="animate-neonFlicker">Order online</span>
              </div>
            </button>
            <button className="mt-0 inline-block" onClick={handleToggleMenu}>
              <div className="heroneon cursor-pointer select-none  min-w-[200px]">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                {currentLabel}
              </div>
            </button>
          </motion.div>
        </motion.div>

        {/* RIGHT */}
        <motion.div
          variants={slideRight}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="relative h-full hidden md:flex items-center justify-end"
        >
          <div className="h-full w-full max-w-md lg:max-w-lg flex items-center justify-center">
            <motion.img
              src="/saigonstar/bg1.webp"
              alt="Hero visual"
              className="w-full h-full rounded-xl object-cover drop-shadow-[0_30px_80px_rgba(0,0,0,0.6)] md:w-[500px] md:h-[500px]"
              transition={{
                duration: 1,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
